/* OO(2026-10-17) 商品ページの「送料」と「発送日数」の表示。会長の指示（10/16）の形。

   【や1】値段の右の「配送料は購入手続き時に計算されます。」を、
     いま選んでいる色・サイズの値段が 20,000円以上のときだけ「送料無料」に入れかえる。
     20,000円未満は元の文のまま。サイズを変えたらその場で入れかわる。

   【や2】値段の下に発送の目安を1行出す。

   【や3】買うボタンの下の表（.oo-buy-reassure）の「お届け」の文を、新しい言い方に入れかえる。

   【や4】ページの下のほうにある「発送・送料について」の欄の中の、
     古い発送日数（ご決済確認完了後、1〜7営業日以内）を新しい言い方に入れかえる。（2026-10-17 追加）

   ★なぜここで入れかえているか（2026-10-16／10-17）
     「お届け」の元の文は sections/main-product.liquid（65KB）の中に、
     「発送・送料について」の元の文は templates/product.json（28KB）の中にあります。
     その大きなファイルを丸ごと書き直すのは危ないため、ここで文だけ差し替えています。
     もしこの仕組みが動かなかった場合は、元の「1〜7営業日以内」が出ます。
     （遅いほうの約束なので、お客さまに迷惑はかかりません）
     いつか元のファイルを直すときは、ここの REASSURE_* と ACC_* を消してください。

   見た目は shop9.css と対。 */
(function () {
  'use strict';

  var THRESHOLD = 2000000; // 20,000円（Shopify は値段を100倍の整数で持つ）
  var SHOW_ETA = true;
  var ETA_TEXT = '通常1〜3営業日以内に発送します（土日祝を除く・混み合う時期は最大7営業日）';
  var FREE_HTML = '<span class="oo-free">送料無料</span>';

  var REASSURE_LABEL = 'お届け';
  var REASSURE_NEW = 'ご注文から通常1〜3営業日で発送（佐川急便・追跡あり）。コンビニ払いはお支払い確認後の発送です。';

  /* ページ下の「発送・送料について」の欄 */
  var ACC_OLD = 'ご決済確認完了後、1〜7営業日以内に発送いたします。';
  var ACC_NEW = 'ご注文から通常1〜3営業日以内に発送いたします（土日祝を除く・混み合う時期は最大7営業日）。コンビニ払いはお支払い確認後の発送です。';
  var ACC_TRIES = 25; // 見つからないときに探す回数の上限（約18秒）

  /* ================================================================
     【や5】決済の案内に PayPay を足す（2026-10-22 会長の指示）

     なぜ足すか:
       直近60件の注文の払い方を調べたところ、**PayPay が11件（約18%）** ありました。
       カード（Shopify Payments）31件、コンビニ払い11件、Paidy 8件に次ぐ多さです。
       それなのに、商品ページの案内に PayPay が書かれていませんでした。
       「PayPayで払えないのかな」と思って離れたお客さまがいたかもしれません。

     元の文は templates/product.json（22KB）の中にあるため、ここで差し替えています。
     文を丸ごと入れかえるので、元の文が変わっても壊れません。
     ★ いつか product.json を直すときは、ここの PAY_NOTE_* を消してください。
     ================================================================ */
  var PAY_NOTE_NEW = 'ほか PayPay・Paidy・コンビニ払い・ペイジー・銀行振込 対応';
  var payNoteDone = false;

  function fixPayNote() {
    if (payNoteDone) return;
    var el = document.querySelector('.oo-buy-reassure__pay-note');
    if (!el) return;
    if ((el.textContent || '').indexOf('PayPay') >= 0) { payNoteDone = true; return; }
    el.textContent = PAY_NOTE_NEW;
    payNoteDone = true;
  }

  var variants = null;
  var lastId = null;
  var lastFree = null;
  var etaBox = null;
  var infoEl = null;
  var infoOriginal = null;
  var reassureDone = false;
  var accDone = false;

  function priceHost() {
    return document.querySelector('.product__price');
  }

  function infoHost() {
    if (infoEl && document.body.contains(infoEl)) return infoEl;
    infoEl = document.querySelector('.product__price--info');
    if (infoEl && infoOriginal === null) infoOriginal = infoEl.innerHTML;
    return infoEl;
  }

  /* 買うボタンの下の表の「お届け」の文を入れかえる */
  function fixReassure() {
    if (reassureDone) return;
    var list = document.querySelector('.oo-buy-reassure');
    if (!list) return;
    var rows = list.querySelectorAll('li');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('.oo-buy-reassure__label');
      if (!label || label.textContent.trim() !== REASSURE_LABEL) continue;
      var spans = rows[i].querySelectorAll('span');
      var body = spans[spans.length - 1];
      if (body && body !== label) {
        body.textContent = REASSURE_NEW;
        reassureDone = true;
      }
      return;
    }
  }

  /* ページ下の「発送・送料について」の文を入れかえる。
     文字のところだけを書きかえるので、ほかの部品は一切こわさない。 */
  function fixAccordion() {
    if (accDone || ACC_TRIES <= 0) return;
    ACC_TRIES--;
    if (document.body.textContent.indexOf(ACC_OLD) === -1) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf(ACC_OLD) !== -1) {
        n.nodeValue = n.nodeValue.split(ACC_OLD).join(ACC_NEW);
        accDone = true;
      }
    }
  }

  function currentVariantId() {
    try {
      var q = new URLSearchParams(window.location.search).get('variant');
      if (q) return Number(q);
    } catch (e) {}
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return Number(input.value);
    return null;
  }

  function ensureEta() {
    if (!SHOW_ETA) return null;
    if (etaBox && document.body.contains(etaBox)) return etaBox;
    var host = priceHost();
    if (!host) return null;
    etaBox = document.createElement('div');
    etaBox.className = 'oo-ship';
    etaBox.innerHTML = '<p class="oo-ship__eta">' + ETA_TEXT + '</p>';
    host.insertAdjacentElement('afterend', etaBox);
    return etaBox;
  }

  function paint() {
    fixReassure();
    fixAccordion();
    fixPayNote();
    if (!variants) return;
    var id = currentVariantId();
    if (id === lastId) return;
    lastId = id;

    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) { v = variants[i]; break; }
    }
    // 選んでいるものが分からないときは、いちばん安いサイズで判断する（言いすぎを防ぐため）
    var price = null;
    if (v) {
      price = v.price;
    } else if (variants.length) {
      price = variants.reduce(function (m, x) { return x.price < m ? x.price : m; }, variants[0].price);
    }

    var free = (typeof price === 'number' && price >= THRESHOLD);
    var el = infoHost();
    if (el && free !== lastFree) {
      el.innerHTML = free ? FREE_HTML : infoOriginal;
      lastFree = free;
    }
    ensureEta();
  }

  function start() {
    if (!document.body.classList.contains('template--product')) return;
    if (!priceHost()) return;
    infoHost();
    fixReassure();
    fixAccordion();
    fixPayNote();

    var path = window.location.pathname.split('?')[0].replace(/\/$/, '');
    fetch(path + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        variants = p.variants.map(function (x) { return { id: x.id, price: x.price }; });
        lastId = null;
        paint();
      })
      .catch(function () {});

    document.addEventListener('change', function () { setTimeout(paint, 60); }, true);
    document.addEventListener('click', function () { setTimeout(paint, 180); }, true);
    window.addEventListener('popstate', function () { setTimeout(paint, 60); });
    setInterval(paint, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
